
import language from "./translation";

export const show404 = () => {
    
    var temp = `
    <div class="row">
        <div class="col-sm-12">
            <div class="article site404">
                <div class="row  justify-content-md-center">
                    <div class="col-sm-4">
                        <img src="/src/assets/images/404-kari.png" alt="" class="site404__img">
                    </div>
                    <div class="col-sm-8">
                        <div class="site404__text">
                            <h1 class="">${language("NO_PAGE")}</h1>
                            <p><strong>${language("NO_PAGE_INTRO")}:</strong></p>
                            <p>
                                ${language("NO_PAGE_ACTIONS")}
                            </p>
                            <!--p><strong>`+(dev === true ? language("NO_PAGE_DB") : "")+ `</strong></p-->
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    
    return temp;
}